var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#fff",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#fff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.71,245.495c-0.081,1.455-0.208,2.91-0.208,4.374v183.444c0,13.31,3.335,25.825,9.163,36.813l137.513-139.7 L18.71,245.495z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.291,245.495l-146.468,84.931l137.513,139.7c5.828-10.988,9.162-23.504,9.162-36.813V249.869 C493.498,248.405,493.372,246.95,493.291,245.495z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,383.089l-66.01-38.277L44.996,492.084C58.894,504.436,77.137,512,97.189,512h317.622 c20.052,0,38.296-7.564,52.193-19.916L322.01,344.812L256,383.089z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,350.993l144.968-84.055v-86.503H111.042v86.503L256,350.993z M173.879,212.829h163.464v21.588H173.879 V212.829z M173.879,259.094h81.732v21.587h-81.732V259.094z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.282,152.676h345.445v98.168l57.669-33.442c-3.47-7.645-8.087-14.784-13.897-21.045L313.687,25.166 C298.796,9.117,277.895,0,256,0c-21.894,0-42.795,9.117-57.686,25.166L39.502,196.356c-5.811,6.262-10.428,13.4-13.898,21.045 l57.678,33.442V152.676z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.5c9db780e54ed16a57b0a201f36c21b5.svg";
export { ForwardRef as ReactComponent };